import type { QuotationStatus } from './api';

/** NKS's words, not the enum. */
export const QUOTATION_STATUS_LABEL: Record<QuotationStatus, string> = {
  DRAFT: 'Draft',
  PENDING_APPROVAL: 'Waiting for approval',
  SENT: 'Sent',
  ACCEPTED: 'Accepted',
  EXPIRED: 'Expired',
  CANCELLED: 'Cancelled',
};

export const LINE_TYPE_LABEL: Record<string, string> = {
  BIKE: 'Motorcycle',
  ACCESSORY: 'Accessory',
  INSURANCE: 'Insurance',
  ROAD_TAX: 'Road tax',
  REGISTRATION: 'Registration',
  SERVICE: 'Service',
  OTHER: 'Other',
};

/** Reserved status band from antd-theme.ts, never the brand colour. */
export function quotationTone(status: QuotationStatus): string | undefined {
  switch (status) {
    case 'ACCEPTED':
      return 'success';
    case 'PENDING_APPROVAL':
      return 'warning';
    case 'CANCELLED':
    case 'EXPIRED':
      return 'error';
    case 'SENT':
      return 'processing';
    default:
      return undefined;
  }
}
